export enum ContentTypes {
    FOLDER = "FOLDER",
    FILE = "FILE",
  }